import { render, staticRenderFns } from "./Changelog.vue?vue&type=template&id=6306c94e&scoped=true"
import script from "./Changelog.vue?vue&type=script&lang=js"
export * from "./Changelog.vue?vue&type=script&lang=js"
import style0 from "./Changelog.vue?vue&type=style&index=0&id=6306c94e&prod&scoped=true&lang=css"
import style1 from "./Changelog.vue?vue&type=style&index=1&id=6306c94e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6306c94e",
  null
  
)

export default component.exports